import React, { useState } from "react";
import InfoOutlined from "@mui/icons-material/InfoOutlined";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Slide,
  Box,
  Button,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function TemplatePreviewer({
  open,
  setOpen,
  templateContent,
  title = "Template Preview",
  onSend,
  loading,
}) {
  const headerComponent =
    templateContent &&
    templateContent?.components?.find(
      (component) => component.type === "HEADER"
    );

  const headerHandle = headerComponent?.example?.file_path;
  const onClose = () => {
    setOpen(false);
  };
  const MessageText =
    templateContent?.components &&
    templateContent?.components.find((comp) => comp.type === "BODY")?.text;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        {templateContent?.name}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
    {headerHandle&&
    
      <div>
        <iframe src={headerHandle} height={"300px"}  width={"100%"}/>
      </div>
    }

      <DialogContent dividers>
        <Box
          display={"flex"}
          sx={{ whiteSpace: "pre-wrap", fontSize: 16, lineHeight: 1.6 }}
        >
          <Tooltip
            arrow
            title={
              <>
                <Typography variant="body2" ml={1}>
                  {"{{1}}"}: Name of the lead
                </Typography>
                <Typography variant="body2">
                  {"{{2}}"}: Phone number of the lead
                </Typography>
              </>
            }
          >
            <InfoOutlined className="tooltip" style={{ cursor: "pointer" }} />
          </Tooltip>

          {" "+MessageText || "No content available."}
        </Box>
      </DialogContent>
      {/* <DialogContent dividers>
        <Box sx={{ whiteSpace: "pre-wrap", fontSize: 16, lineHeight: 1.6 }}>
          {headerType || "No content available."}
        </Box>
      </DialogContent> */}

      <DialogActions>
        <Button onClick={onClose} color="error" variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={onSend}
          sx={{
            background: "#FAAB53",
            color: "white !important",
            ml: 1,
            ":hover": { background: "#FAAB53" },
          }}
          disabled={loading}
        >
          {loading ? "Sending..." : "Send"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default TemplatePreviewer;
